import { render, staticRenderFns } from "./ItemHistorico.vue?vue&type=template&id=659472c2&lang=pug"
import script from "./ItemHistorico.vue?vue&type=script&lang=js"
export * from "./ItemHistorico.vue?vue&type=script&lang=js"
import style0 from "./ItemHistorico.vue?vue&type=style&index=0&id=659472c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports